export default __webpack_public_path__ + "static/RunRight4-9136789586cde82fa3af5a9175d26deb.mp3";